import React from 'react';
import CreateRollover from '../components/rollover/CreateRollover';

const CreateRolloverPage = () => {
  return <CreateRollover />;
};

export default CreateRolloverPage;